import React from "react";
import PropTypes from "prop-types";
import "./Video.scss";

const YouTube = ({ url }) => {
  const videoId = url.split("v=")[1]?.split("&")[0];

  if (!videoId) {
    return <p>Invalid YouTube URL</p>;
  }

  return (
    <div className="youtube-container">
      <iframe
        title={`YouTube Video - ${videoId}`}
        src={`https://www.youtube.com/embed/${videoId}`}
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
      />
    </div>
  );
};

YouTube.propTypes = {
  url: PropTypes.string.isRequired,
};

export default YouTube;
